import {
  LuBell, LuBellRing, LuBot, LuBuilding2, LuCalendarDays, LuCirclePlus, LuCpu, LuDatabase,
  LuFilter, LuKey, LuLanguages, LuLayoutGrid, LuLink, LuMic, LuPlug, LuSave,
  LuSettings, LuShieldCheck, LuSlidersHorizontal, LuToggleRight, LuUsers, LuWebhook, LuChartColumn,
  LuFileText, LuPanelRight,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('settings', '/settings', null, [
    ['tabs', 'settings.tabs', LuSettings],
    ['grid', 'settings.grid', LuLayoutGrid, { placement: 'top', ...opt }],
  ], { exact: true }),
  // Company tab: /company/update-details redirects to /company/<id>/edit.
  tour('settings_company', '/company', null, [
    ['details', 'settings_company.details', LuBuilding2, { placement: 'right' }],
    ['context', 'settings_company.context', LuPanelRight, { placement: 'left' }],
    ['save', 'settings_company.save', LuSave, { placement: 'top', ...opt }],
  ]),
  tour('settings_users', '/users/list', null, [
    ['list', 'settings_users.list', LuUsers, { placement: 'top' }],
    ['filters', 'settings_users.filters', LuFilter],
  ]),
  // Configuration ▾ entries.
  tour('settings_ai', '/settings/ai', null, [
    ['providers', 'settings_ai.providers', LuCpu, { placement: 'right' }],
    ['form', 'settings_ai.form', LuSlidersHorizontal, { placement: 'left' }],
    ['voice', 'settings_ai.voice', LuMic, { placement: 'top', ...opt }],
  ]),
  tour('settings_ai_personas', '/settings/ai-personas', null, [
    ['list', 'settings_ai_personas.list', LuBot, { placement: 'top' }],
    ['new', 'settings_ai_personas.new', LuCirclePlus],
  ]),
  tour('settings_gateways', '/settings/gateways', null, [
    ['list', 'settings_gateways.list', LuPlug, { placement: 'right' }],
    ['form', 'settings_gateways.form', LuSlidersHorizontal, { placement: 'left' }],
  ]),
  tour('settings_integrations', '/integrations', null, [
    ['new', 'settings_integrations.new', LuWebhook],
    ['kpis', 'settings_integrations.kpis', LuChartColumn, opt],
    ['security', 'settings_integrations.security', LuShieldCheck],
  ]),
  tour('settings_translations', '/settings/translations', null, [
    ['languages', 'settings_translations.languages', LuLanguages, { placement: 'right' }],
    ['keys', 'settings_translations.keys', LuFileText, { placement: 'left' }],
  ]),
  tour('settings_resource_calendars', '/settings/resource-calendars', null, [
    ['list', 'settings_resource_calendars.list', LuCalendarDays, { placement: 'top' }],
    ['new', 'settings_resource_calendars.new', LuCirclePlus],
  ], { exact: true }),
  tour('settings_api_keys', '/settings/api-keys', null, [
    ['keys', 'settings_api_keys.keys', LuKey, { placement: 'top' }],
    ['new', 'settings_api_keys.new', LuCirclePlus, opt],
  ]),
  tour('settings_custom_fields', '/settings/custom-fields', null, [
    ['list', 'settings_custom_fields.list', LuDatabase, { placement: 'top' }],
    ['add', 'settings_custom_fields.add', LuCirclePlus],
  ]),
  tour('settings_zoho', '/settings/zoho', null, [
    ['connection', 'settings_zoho.connection', LuLink, { placement: 'top' }],
    ['actions', 'settings_zoho.actions', LuToggleRight, { placement: 'top', ...opt }],
  ]),
  tour('settings_notifications', '/settings/notifications', null, [
    ['intro', 'settings_notifications.intro', LuBell],
    ['master', 'settings_notifications.master', LuToggleRight, opt],
    ['events', 'settings_notifications.events', LuBellRing, { placement: 'top', ...opt }],
  ]),
];

export default tours;
